<script setup lang="ts">

import { useModal } from "@library/Components";
import { SelectAppStoreModal } from "@components/SelectAppStoreModal";
import { useScreenState } from "@library/Utilities";

interface Props
{
    showGetInTouch?: boolean
}

const { showGetInTouch = true } = defineProps<Props>();

const modal = useModal( SelectAppStoreModal, null, { fullScreen: false, frameless: true } );
const openLink = () => 
{
    const screenState = useScreenState();
    if( screenState.isMobile )
    {
        window.open( 'https://onelink.to/carbucks', '_blank' );
        return;
    }
    modal.open();
}

</script>

<template>

    <div class="flex gap-8 items-center justify-center">
        <Button variant="flat"
            color="var(--color-primary-600)"
            size="large"
            class="get-the-app-shadow !h-16 text-white !rounded-[8px] tracking-wider"
            :class="{ 'flex-1': showGetInTouch == false }"
            @click="openLink()">
            <Icon name="apple" class="text-2xl mr-1.5"></Icon>
            <Icon name="google-play" class="text-lg mr-3"></Icon>
            <span class="text-sm">Get The App</span>
        </Button>

        <a v-if="showGetInTouch"
            href="mailto:sales@connectedvehicles.com.au?subject=Carbucks Protect enquiry"
            class="text-sm font-semibold flex items-center">
            GET IN TOUCH
            &raquo;
        </a>
    </div>

</template>

<style lang="scss">

    .get-the-app-shadow 
    {
        box-shadow: 0 1px 1px rgba(0,0,0,0.05), 
                    0 2px 2px rgba(0,0,0,0.05), 
                    0 4px 4px rgba(0,0,0,0.04), 
                    0 8px 8px rgba(0,0,0,0.03),
                    0 16px 16px rgba(0,0,0,0.01);
    }

</style>